function t(t,e=36){return e/2-Math.ceil(t/2)}export{t as getProgressCircleRadius};
